document.addEventListener("DOMContentLoaded", () => {
  const cart = document.querySelector(".xoo-wsc-markup");
  const target = document.querySelector("body");

  if (cart && target) {
    target.appendChild(cart);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.querySelector(
    ".single_add_to_cart_button.button.alt",
  );

  if (
    addToCartButton &&
    !addToCartButton.parentElement.classList.contains(
      "custom-add-to-cart-wrapper",
    )
  ) {
    const wrapper = document.createElement("span");
    wrapper.classList.add("custom-add-to-cart-wrapper");

    addToCartButton.parentNode.insertBefore(wrapper, addToCartButton);
    wrapper.appendChild(addToCartButton);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const historyPrice = document.querySelector(
    ".wc-price-history.prior-price.lowest",
  );
  const target = document.querySelector(".custom-quantity");

  if (historyPrice && target) {
    target.appendChild(historyPrice);
  }
});
